// These types have been converted from frozen objects to enums.
// We cannot change their name, or even capitalise them without breaking API.
export let envType = /*#__PURE__*/function (envType) {
  envType["LOCAL"] = "local";
  envType["DEV"] = "dev";
  envType["STAGING"] = "staging";
  envType["PROD"] = "prod";
  return envType;
}({});
export let eventType = /*#__PURE__*/function (eventType) {
  eventType["TRACK"] = "track";
  eventType["UI"] = "ui";
  eventType["OPERATIONAL"] = "operational";
  eventType["SCREEN"] = "screen";
  eventType["IDENTIFY"] = "identify";
  return eventType;
}({});
export let platformType = /*#__PURE__*/function (platformType) {
  platformType["MAC"] = "mac";
  platformType["LINUX"] = "linux";
  platformType["WINDOWS"] = "windows";
  platformType["DESKTOP"] = "desktop";
  platformType["WEB"] = "web";
  platformType["MOBILE_WEB"] = "mobileWeb";
  return platformType;
}({});
export let originType = /*#__PURE__*/function (originType) {
  originType["DESKTOP"] = "desktop";
  originType["WEB"] = "web";
  return originType;
}({});
export let tenantType = /*#__PURE__*/function (tenantType) {
  tenantType["CLOUD_ID"] = "cloudId";
  tenantType["ORG_ID"] = "orgId";
  tenantType["OPSGENIE_CUSTOMER_ID"] = "opsgenieCustomerId";
  tenantType["HALP_TEAM_ID"] = "halpTeamId";
  tenantType["TRANSACTION_ACCOUNT_ID"] = "transactionAccountId";
  tenantType["TRELLO_WORKSPACE_ID"] = "trelloWorkspaceId";
  tenantType["NONE"] = "none";
  return tenantType;
}({});
export let userType = /*#__PURE__*/function (userType) {
  userType["ATLASSIAN_ACCOUNT"] = "atlassianAccount";
  userType["HASHED_EMAIL"] = "hashedEmail";
  userType["TRELLO"] = "trello";
  userType["OPSGENIE"] = "opsgenie";
  userType["HALP"] = "halp";
  return userType;
}({});
export let apdexType = /*#__PURE__*/function (apdexType) {
  apdexType["TRANSITION"] = "transition";
  apdexType["INITIAL_LOAD"] = "initialLoad";
  return apdexType;
}({});
export const desktopPlatforms = Object.freeze([platformType.DESKTOP, platformType.MAC, platformType.LINUX, platformType.WINDOWS]);
export const webPlatforms = Object.freeze([platformType.WEB, platformType.MOBILE_WEB]);
export let originTracingType = /*#__PURE__*/function (originTracingType) {
  originTracingType["ATL_ORIGIN"] = "atlOrigin";
  return originTracingType;
}({});
export function objectValues(object) {
  return Object.values(object);
}
export function isType(type, value) {
  return Object.values(type).indexOf(value) > -1;
}
export let perimeterType = /*#__PURE__*/function (perimeterType) {
  perimeterType["C5"] = "c5";
  perimeterType["COMMERCIAL"] = "commercial";
  perimeterType["FEDRAMP_MODERATE"] = "fedramp-moderate";
  perimeterType["FEDRAMP_HIGH"] = "fedramp-high";
  return perimeterType;
}({});